import "../css/stacked-cards.css";
document.addEventListener("DOMContentLoaded", () => {
  /* Página de archivo de Challenges */
  const cards = [...document.querySelectorAll("body.page-template-page-challenges ul.wp-block-post-template .aachallenges")];
  if (cards.length) { cards_animation_setup(); }

  function cards_animation_setup() {

    // Ajusta estos px cuando quieras
    const STACK_GAP = 14;     // debe coincidir con --stack-gap
    const STACK_BASE = 0;     // debe coincidir con --stack-base
    const DEPTH_RANGE = 260;  // "distancia" de scroll para alejarse a tope

    const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

    // Asigna índice para top escalonado sin nth-child infinito
    cards.forEach((card, idx) => card.style.setProperty("--i", idx));

    const tick = () => {
      for (let i = 0; i < cards.length; i++) {
        const card = cards[i];
        const rect = card.getBoundingClientRect();
        const targetTop = STACK_BASE + (i * STACK_GAP);

        // d > 0: aún va "subiendo" hacia su spot => 100% (sin blur)
        const d = rect.top - targetTop;

        if (d > 0) {
          card.style.transform = "translateZ(0px) scale(1)";
          card.style.opacity = "1";
          card.style.filter = "none";
          continue;
        }

        // d <= 0: ya está en el stack => se aleja gradualmente con el scroll
        const t = clamp((-d) / DEPTH_RANGE, 0, 1);

        // Valores base (en px) para que luego ajustes:
        const z = -240 * t;          // más negativo => más lejos
        const s = 1 - (0.10 * t);    // escala final ~0.90
        const o = 1 - (0.30 * t);    // opacidad final ~0.70

        card.style.transform = `translateZ(${z}px) scale(${s})`;
        card.style.opacity = String(o);

        // SIN BLUR (como pediste)
        card.style.filter = "none";
      }

      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  }

  /* Bloque preview de Challenges (home y solutions) */
  const $previewCards = jQuery('.cards .aachallenges');
  if ($previewCards.length) { cards_block_animation_setup($previewCards); }

  function cards_block_animation_setup() {
    console.log("Setting up cards block animation...");
    const total = $previewCards.length;
    let cur = 0;
    const $dotsEl = jQuery('#dots');

    for (let i = 0; i < total; i++) {
      $dotsEl.append(jQuery('<div>').addClass('dot' + (i === 0 ? ' on' : '')));
    }
    const $stackArea = jQuery('.cards');

    function render() {
      $previewCards.each(function (i) {
        const pos = (i - cur + total) % total;
        jQuery(this).attr('class', 'aachallenges');
        if (pos === 0) {
          jQuery(this).addClass('active');
        } else {
          jQuery(this).addClass('behind').css('--depth', pos);
        }
      });
      $dotsEl.find('.dot').each(function (i) {
        jQuery(this).attr('class', 'dot' + (i === cur ? ' on' : ''));

        jQuery(this).on('click', function (e) {
          e.stopPropagation();
          cur = jQuery(this).index();
          render();
        });
      });
      setStackHeight();
    }

    function setStackHeight() {
      const maxH = Math.max(...$previewCards.map(function () {
        return jQuery(this).outerHeight();
      }).get());
      $stackArea.height(maxH);
    }

    function next() { cur = (cur + 1) % total; render(); }

    let timer = null;
    const startAutoplay = () => {
      if (timer) { return; }
      timer = setInterval(next, 4000);
    };

    const stopAutoplay = () => {
      if (!timer) { return; }
      clearInterval(timer);
      timer = null;
    };

    render();
    startAutoplay();

    const $columnHoverArea = jQuery('.wp-block-column:has(.cards)');
    const $hoverAreas = $columnHoverArea.length ? $columnHoverArea : jQuery('.cards, #dots');

    $hoverAreas.on('mouseenter', stopAutoplay).on('mouseleave', startAutoplay);

    jQuery(window).on('resize', setStackHeight);
  }

});
